import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Close } from '@mui/icons-material';
import { Alert, Box, IconButton, Tooltip } from '@mui/material';
import { constVoid } from 'fp-ts/function';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { createContext } from 'react';
import { useStyles } from 'tss-react/mui';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DESKTOP_NAV_HEIGHT = 64;
var ALERT_TOP = DESKTOP_NAV_HEIGHT + 10;
var durationToMsMap = {
  "short": 3000,
  medium: 5000,
  "long": 10000,
  unlimited: null
};
export var AppAlertsContext = /*#__PURE__*/createContext({
  showAlert: constVoid
});

var AlertsProvider = function AlertsProvider(_ref) {
  var children = _ref.children;

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  var showAlert = function showAlert(_ref2) {
    var severity = _ref2.severity,
        message = _ref2.message,
        component = _ref2.component,
        duration = _ref2.duration,
        action = _ref2.action,
        sx = _ref2.sx,
        icon = _ref2.icon,
        _ref2$closeSx = _ref2.closeSx,
        closeSx = _ref2$closeSx === void 0 ? {} : _ref2$closeSx;
    enqueueSnackbar(message, {
      content: function content(key, message) {
        return component ? /*#__PURE__*/_jsx(Box, {
          children: component(function () {
            return closeSnackbar(key);
          })
        }) : /*#__PURE__*/_jsx(Alert, {
          severity: severity,
          sx: mergeSxProps(sx, {
            mb: 1
          }),
          icon: icon,
          action: /*#__PURE__*/_jsxs(_Fragment, {
            children: [action, /*#__PURE__*/_jsx(Tooltip, {
              title: "Close",
              enterDelay: 500,
              leaveDelay: 200,
              children: /*#__PURE__*/_jsx(IconButton, {
                size: "small",
                onClick: function onClick() {
                  return closeSnackbar(key);
                },
                children: /*#__PURE__*/_jsx(Close, {
                  sx: mergeSxProps({
                    width: 20,
                    height: 20
                  }, closeSx)
                })
              })
            })]
          }),
          children: message
        });
      },
      autoHideDuration: durationToMsMap[duration],
      anchorOrigin: component ? {
        vertical: 'top',
        horizontal: 'right'
      } : {
        vertical: 'bottom',
        horizontal: 'left'
      }
    });
  };

  return /*#__PURE__*/_jsx(AppAlertsContext.Provider, {
    value: {
      showAlert: showAlert
    },
    "data-element": "unknown",
    "data-component": "AlertsProvider",
    "data-source-file": "app-alerts.tsx",
    children: children
  });
};

export var AppAlerts = function AppAlerts(_ref3) {
  var children = _ref3.children;

  var _useStyles = useStyles(),
      css = _useStyles.css,
      theme = _useStyles.theme;

  return /*#__PURE__*/_jsx(SnackbarProvider, {
    classes: {
      containerRoot: css(_defineProperty({
        top: "".concat(ALERT_TOP, "px !important"),
        right: "".concat(theme.spacing(2), " !important")
      }, theme.breakpoints.up('xs'), {
        width: '90% !important'
      }))
    },
    "data-element": "SnackbarProvider",
    "data-component": "AppAlerts",
    "data-source-file": "app-alerts.tsx",
    children: /*#__PURE__*/_jsx(AlertsProvider, {
      "data-element": "AlertsProvider",
      "data-component": "AppAlerts",
      "data-source-file": "app-alerts.tsx",
      children: children
    })
  });
};